module.exports = __webpack_public_path__ + "img/woodoc.b5e6e731.jpg";